/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { getGenreParam } from '../../utils/getSearchParam';
import {
  H1, FlexBox, ClickableBox, SpacingBox,
} from '../../Components';
import { navigateToProductListWithClusterAndGenre } from '../../utils/navigations';
import { existsAndNotEmptyString, join } from '../../utils/strings';
import { getTranslateByScope } from '../../i18n';

const clustersTranslations = getTranslateByScope('clusters');

export const ProductTitle = (props) => (
  <FlexBox justifyContent="center" marginVertical="lg">
    <H1>{props.description}</H1>
  </FlexBox>
);

export const ProductTitleForClusters = withRouter((props) => {
  const genre = getGenreParam(props.location);
  const onClick = (clusters) => {
    if (clusters === genre) {
      navigateToProductListWithClusterAndGenre({
        history: props.history,
        genre,
      });
    }
    if (clusters) {
      navigateToProductListWithClusterAndGenre({
        history: props.history,
        genre,
        clusters: join({ part1: genre, part2: clusters, separator: '|' }),
      });
    }
  };

  const clusters = _.uniq(props.clusters.split(' | '));

  return (
    <FlexBox justifyContent="center" marginVertical="xxl">
      <ClickableBox>
        <SpacingBox>
          <H1>{existsAndNotEmptyString(props.cluster) ? ' |' : ''}</H1>
        </SpacingBox>
      </ClickableBox>
      {clusters.map((part, index) => (
        <ClickableBox key={part} onClick={() => onClick(part, index)}>
          <SpacingBox>
            <H1>{`${clustersTranslations(part)} ${
              index !== clusters.length - 1 ? '|' : ''
            }`}</H1>
          </SpacingBox>
        </ClickableBox>
      ))}
    </FlexBox>
  );
});
